<footer class="cinema-footer">
  <!-- Ambient Projector Beams & Floating Stage -->
  <div class="cinema-backdrop">
    <div class="projector-ambient-light"></div>
    <div class="film-grain-overlay"></div>
    <div class="icon-stage" #stage></div>
  </div>

  <!-- Top Cinematic Perforation Strip -->
  <div class="film-strip-header" aria-hidden="true">
    <div class="perforation-track"></div>
  </div>


  <div class="footer-container">
    <!-- Highlight: Auteur Dialogue Marquee Box -->
    <section class="dialogue-marquee-section" aria-label="Featured Cinema Dialogue">
      <div class="marquee-glass-plaque">
        <div class="marquee-accent-strip"></div>
        <div class="marquee-badge-row">
          <div class="clapper-icon-badge">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="M2 8h20" />
              <path d="M6 4l3 4" />
              <path d="M12 4l3 4" />
              <path d="M18 4l3 4" />
            </svg>
            <span>MEMORABLE DIALOGUE</span>
          </div>
        </div>

        <div class="dialogue-embed-wrapper">
          <app-dialogue-component></app-dialogue-component>
        </div>
      </div>
    </section>

    <!-- Main 4-Column Cinematic Navigation Grid -->
    <div class="cinema-grid">
      <!-- Column 1: Brand & Legacy -->
      <div class="footer-col brand-col">
        <div class="brand-header">
          <div class="brand-reel-icon">
            <img src="/assets/images/icon.png" alt="Cinema" class="brand-logo-img">
          </div>
          <div class="brand-titles">
            <span class="brand-main-title">THE SCENETALE</span>
            <span class="brand-sub-title">SANCTUARY OF THE MOVING IMAGE</span>
          </div>
        </div>

        <p class="brand-manifesto">
          The definitive sanctuary for cinema purists, midnight screeners, and trivia masters.
          From golden age noir to contemporary masterpieces, tracking film history one frame at a time.
        </p>

      </div>

      <!-- Column 2: Screenings & Archives -->
      <div class="footer-col nav-col">
        <h3 class="col-title">
          <span class="col-title-bar"></span>
          Screenings & Archives
        </h3>
        <ul class="footer-links">
          <li>
            <a routerLink="/" class="footer-link">
              <span class="link-arrow">&rsaquo;</span>
              <span>Trending Releases</span>
            </a>
          </li>
          <li>
            <a routerLink="/movies" class="footer-link">
              <span class="link-arrow">&rsaquo;</span>
              <span>Top Rated Classics</span>
            </a>
          </li>
          <li>
            <a routerLink="/calendar" class="footer-link">
              <span class="link-arrow">&rsaquo;</span>
              <span>Theatrical Calendar</span>
            </a>
          </li>
          <li>
            <a routerLink="/person" class="footer-link">
              <span class="link-arrow">&rsaquo;</span>
              <span>Directors & Legends</span>
            </a>
          </li>
          <li>
            <a routerLink="/blog" class="footer-link">
              <span class="link-arrow">&rsaquo;</span>
              <span>Cinephile Journal</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Column 3: The Cinephile Arena -->
      <div class="footer-col nav-col">
        <h3 class="col-title">
          <span class="col-title-bar teal-bar"></span>
          Cinephile Arena
        </h3>
        <ul class="footer-links">
          <li>
            <a routerLink="/quiz" class="footer-link highlight-link">
              <span class="link-arrow">&rsaquo;</span>
              <span>Daily Trivia Arena</span>
            </a>
          </li>
          <li>
            <a routerLink="/quiz/leaderboard" class="footer-link">
              <span class="link-arrow">&rsaquo;</span>
              <span>Global Hall of Fame</span>
            </a>
          </li>
          <li>
            <a routerLink="/quiz/vault" class="footer-link">
              <span class="link-arrow">&rsaquo;</span>
              <span>The Collectible Vault</span>
            </a>
          </li>
          <li>
            <a routerLink="/quiz/dashboard" class="footer-link">
              <span class="link-arrow">&rsaquo;</span>
              <span>My Ticket Dashboard</span>
            </a>
          </li>
          <li>
            <a routerLink="/contact" class="footer-link">
              <span class="link-arrow">&rsaquo;</span>
              <span>Curator Support</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Column 4: VIP Newsletter & Dispatch -->
      <div class="footer-col dispatch-col">
        <h3 class="col-title">
          <span class="col-title-bar"></span>
          The Midnight Dispatch
        </h3>
        <p class="dispatch-desc">
          Receive secret screening invites, deep-dive retrospective essays, and weekly trivia drops.
        </p>

        <form class="newsletter-form" (submit)="$event.preventDefault(); subscribeNewsletter()">
          <div class="newsletter-input-wrap" *ngIf="!newsletterSubscribed">
            <div class="input-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
            </div>
            <input type="email" [(ngModel)]="newsletterEmail" name="newsletterEmail"
              placeholder="cinephile@scenetale.com" aria-label="Email address for cinema dispatch" required />
            <button type="submit" class="newsletter-submit-btn" aria-label="Subscribe to dispatch">
              <span>Pass</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
          </div>

          <div class="newsletter-success" *ngIf="newsletterSubscribed">
            <div class="ticket-stamp">
              <span class="ticket-icon">🎟️</span>
              <div>
                <strong>VIP PASS ISSUED</strong>
                <p>Welcome to The Director's Club. Check your inbox.</p>
              </div>
            </div>
          </div>
        </form>

        <div class="dispatch-guarantee">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <span>Dispatched every Friday at midnight </span>
        </div>
      </div>
    </div>

    <!-- Divider Bar with Reel Accents -->
    <div class="footer-divider-line">
      <span class="divider-reel-center">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="2" x2="12" y2="22" />
          <line x1="2" y1="12" x2="22" y2="12" />
        </svg>
      </span>
    </div>

    <!-- Bottom Metadata & Legal Bar -->
    <div class="footer-bottom-bar">
      <!-- Upper Sub-row: TMDB on left, Policy Navigation on right -->
      <div class="bottom-main-row">

        <nav class="footer-policy-nav" aria-label="Legal and Information">
          <a routerLink="/about" class="policy-link">About Us</a>
          <span class="policy-dot">&bull;</span>
          <a routerLink="/privacy-policy" class="policy-link">Privacy Policy</a>
          <span class="policy-dot">&bull;</span>
          <a routerLink="/terms" class="policy-link">Terms of Service</a>
          <span class="policy-dot">&bull;</span>
          <a routerLink="/disclaimer" class="policy-link">Disclaimer</a>
          <span class="policy-dot">&bull;</span>
          <a routerLink="/contact" class="policy-link">Contact</a>
        </nav>
      </div>

      <!-- Lower Sub-row: Copyright notice -->
      <div class="bottom-sub-row">
        <span class="copyright-text">
          &copy; {{ currentYear }} <strong>The Scenetale</strong>. Built for the love of celluloid.
        </span>
      </div>
    </div>
  </div>
</footer>